import { render, staticRenderFns } from "./AiGeneratorAngularAdapter.vue?vue&type=template&id=0c1fcb60&scoped=true"
import script from "./AiGeneratorAngularAdapter.vue?vue&type=script&lang=js"
export * from "./AiGeneratorAngularAdapter.vue?vue&type=script&lang=js"
import style0 from "./AiGeneratorAngularAdapter.vue?vue&type=style&index=0&id=0c1fcb60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1fcb60",
  null
  
)

export default component.exports